import { marketOverviewStore } from './../MarketOverview/MarketOverviewStore';
import { IMarketIndex, STOCK_BG_COLOR_CONIG } from './../../common/model/Model';
import { observable } from "mobx"
import Constants from "../../common/constants/Constants"
import HttpStatusCode from "../../common/constants/HttpErrorCode"
import { getRequest } from "../../common/helpers/RequestHelper"
import { IShortCompanyInfo, IStockSymbol } from "../../common/model/Model"
import _ from 'lodash'
import { appStore } from "../../common/store/AppStore"
export enum CashFlowTrendingByDay {
    One = 1,
    Five = 5,
    Ten = 10,
    Twenty = 20
}
export enum CashFlowTrendingType {
    ByDay = 1,
    Foreign = 2
}
export interface ICashFlowTrendingInfo {
    name: string;
    y: number;
    price: number;
    basicPrice: number;
    quantities: number;
    value: number;
}
export enum IndexSymbolFilterType {
    HOSE = "VNINDEX",
    HNX = "HNXINDEX",
    UPCOM = "UPCOMINDEX"
}
export interface IForeignInfo {
    buyData: any[][];
    sellData: any[][];
    netData: any[][];
}
class CashFlowTrendingStore {
    @observable cashFlowTrendingByDayInfo?: ICashFlowTrendingInfo[]
    @observable cashFlowTrendingType: number = CashFlowTrendingType.ByDay
    @observable day: number = CashFlowTrendingByDay.One
    @observable indexSymbol: string = IndexSymbolFilterType.HOSE
    @observable currentSymbol: string = ""
    @observable cashFlowTrendingByForeignInfo?: IForeignInfo
    @observable keySearch: string = ""
    @observable showAutoCompleteForm: boolean = false
    @observable listShortCompany: IShortCompanyInfo[] = []
    @observable symbolActive: string = ""
    @observable stockSymbolInfo?: IStockSymbol
    @observable marketSymbolInfo?: IMarketIndex
    async getCashFlowTrendingByInfo(notDelay?:boolean) {
        marketOverviewStore.regisMarketInfo()
        let api = ""
        if (this.day === CashFlowTrendingByDay.One) {
            api = "CashFlowTrending?indexSymbol=" + this.indexSymbol
        }
        else api = "CashFlowTrendingByDay?indexSymbol=" + this.indexSymbol + "&day=" + this.day
        const result = await getRequest(Constants.API_DASHBOARD_URL + api,notDelay?false:true)
        if (result.status < HttpStatusCode.CODE_300) {
            this.cashFlowTrendingByDayInfo = result.body

        }
    }
    updateStockSymbol(data: IStockSymbol[]) {
        let newStock = data.find((index) => (index.stockSymbol === this.symbolActive))
        if (newStock) {
            let t: IStockSymbol = _.cloneDeep(newStock);
            if (this.stockSymbolInfo && this.stockSymbolInfo.matchPrice && t.matchPrice && this.stockSymbolInfo.matchPrice < t.matchPrice) {
                t.colorUpdate = STOCK_BG_COLOR_CONIG.UP
            }
            if (this.stockSymbolInfo && this.stockSymbolInfo.matchPrice && t.matchPrice && this.stockSymbolInfo.matchPrice > t.matchPrice) {
                t.colorUpdate = STOCK_BG_COLOR_CONIG.DOWN
            }
            if (this.stockSymbolInfo) {
                if (this.stockSymbolInfo.matchPrice !== t.matchPrice) {
                    this.stockSymbolInfo = t
                    setTimeout(() => {
                        if (this.stockSymbolInfo)
                            this.stockSymbolInfo.colorUpdate = ""
                    }, Constants.EFFECT_UPDATE_TIME)
                    this.stockSymbolInfo = t
                }
            }
            else {
                this.stockSymbolInfo = t
                setTimeout(() => {
                    if (this.stockSymbolInfo)
                        this.stockSymbolInfo.colorUpdate = ""
                }, Constants.EFFECT_UPDATE_TIME)
                this.stockSymbolInfo = t
            }
            // setTimeout(() => {
            //     if (this.topUpDownStockInfo) {
            //         this.topUpDownStockInfo[index].isUpdate = false
            //     }
            // }, 100)
        }
    }
    updateMarketSymbold(data: IMarketIndex[]) {
        let newInfo = data.find((index) => (index.stockSymbol === ('^' + this.indexSymbol)))
        if (newInfo) {
            const t = _.cloneDeep(newInfo)
            if (this.marketSymbolInfo && this.marketSymbolInfo.chgIndex && t.chgIndex && this.marketSymbolInfo.chgIndex < t.chgIndex) {
                t.colorUpdate = STOCK_BG_COLOR_CONIG.UP
            }
            else t.colorUpdate = STOCK_BG_COLOR_CONIG.DOWN
            this.marketSymbolInfo = t
            setTimeout(() => {
                if (this.marketSymbolInfo)
                    this.marketSymbolInfo.colorUpdate = ""
            }, Constants.EFFECT_UPDATE_TIME)
        }
    }
    async getCashFlowTrendingForeign() {
        let symbolActive = _.cloneDeep(this.currentSymbol)
        this.symbolActive = symbolActive;
        appStore.regisShortStockInfo()
        const result = await getRequest(Constants.API_DASHBOARD_URL + 'CashFlowTrendForeign?code=' + this.currentSymbol)
        if (result.status < HttpStatusCode.CODE_300) {
            result.body.buyData.map((item) => {
                // @ts-ignore
                item[0] = (new Date(new Date(item[0]).getTime()) - new Date(item[0]).getTimezoneOffset() * 60 * 1000)
            })
            result.body.sellData.map((item) => {
                // @ts-ignore
                item[0] = (new Date(new Date(item[0]).getTime()) - new Date(item[0]).getTimezoneOffset() * 60 * 1000)
            })
            result.body.netData.map((item) => {
                // @ts-ignore
                item[0] = (new Date(new Date(item[0]).getTime()) - new Date(item[0]).getTimezoneOffset() * 60 * 1000)
            })
            this.cashFlowTrendingByForeignInfo = result.body
        }
    }
    handleIndexSymbolChange(indexSymbol) {
        this.indexSymbol = indexSymbol;
        this.cashFlowTrendingByDayInfo = undefined
        this.getCashFlowTrendingByInfo(true)
    }
    handleDayChange(day) {
        this.day = day
        this.cashFlowTrendingByDayInfo = undefined
        this.getCashFlowTrendingByInfo(true)
    }
    handleTrendingTypeChange(type) {
        this.cashFlowTrendingType = type
        if (type === CashFlowTrendingType.Foreign) {
            this.getCashFlowTrendingForeign()
            this.getListCompanyShortInfo()
        }
        else {
            this.getCashFlowTrendingByInfo()
        }
    }
    async getListCompanyShortInfo() {
        this.listShortCompany = _.cloneDeep(appStore.listShortCompany)
    }
    async handleSymbolSelect(symbol) {
        cashFlowTrendingStore.showAutoCompleteForm = false
        cashFlowTrendingStore.currentSymbol = symbol
        cashFlowTrendingStore.keySearch = ""
        cashFlowTrendingStore.getCashFlowTrendingForeign()
    }
    handleChageInputSearch(key: string) {
        cashFlowTrendingStore.keySearch = key
        if (key) {
            cashFlowTrendingStore.showAutoCompleteForm = true
            cashFlowTrendingStore.listShortCompany.map((item) => {

                if (item.value.toUpperCase().indexOf(key.toUpperCase()) > -1) {
                    item.isHide = false
                }
                else item.isHide = true
            })
            let t = _.cloneDeep(cashFlowTrendingStore.listShortCompany)
            t.sort((a, b) => {
                if (a.value.toLowerCase().indexOf(key.toLowerCase()) > b.value.toLowerCase().indexOf(key.toLowerCase())) {
                    return 1;
                } else if (a.value.toLowerCase().indexOf(key.toLowerCase()) < b.value.toLowerCase().indexOf(key.toLowerCase())) {
                    return -1;
                } else {
                    if (a.value > b.value)
                        return 1;
                    else
                        return -1;
                }
            });
            cashFlowTrendingStore.listShortCompany = t
        }
        else {
            cashFlowTrendingStore.showAutoCompleteForm = false
        }
    }
}
export const cashFlowTrendingStore = new CashFlowTrendingStore()